import { useTranslation, Trans } from 'react-i18next'

import SectionTitle from 'components/SectionTitle'

import { camera, dresses, mapleLeaf, suits } from 'resources/images'
import {
	InfoWrapper,
	SectionContent,
	DressCodeContainer,
	ItemTitle,
	ItemContainer,
	ItemIcon,
	ItemDescription,
	ExampleImageSection,
	DressImage,
	SuitsImage,
	AlertBox,
	ImageIcon,
	Hashtag,
	Tagging,
} from './styles'

function Info() {
	const { t } = useTranslation()

	return (
		<InfoWrapper id="info">
			<div className="container">
				<SectionTitle>{t('Informações')}</SectionTitle>

				<SectionContent>
					<DressCodeContainer>
						<div className="row">
							<div className="col-xs-12 col-md-8">
								<ItemTitle>
									<strong>{t('Traje')}:</strong> {t('Social')}
								</ItemTitle>
								<ItemContainer>
									<ItemIcon src={mapleLeaf} alt={t('Folha de bordo')} />
									<ItemDescription>
										<strong>{t('Para os Homens')}:</strong>{' '}
										{t('O uso da gravata é opcional.')}
									</ItemDescription>
								</ItemContainer>
								<ItemContainer>
									<ItemIcon src={mapleLeaf} alt={t('Folha de bordo')} />
									<ItemDescription>
										<strong>{t('Para as Mulheres')}:</strong>{' '}
										{t(
											'Recomendamos um look que combine com a leveza do campo, e o uso de sapatos com salto grosso devido ao terreno do local.',
										)}
									</ItemDescription>
								</ItemContainer>
							</div>
							<ExampleImageSection className="col-xs-12 col-md-4">
								<DressImage src={suits} alt="" />
								<SuitsImage src={dresses} alt="" />
							</ExampleImageSection>
						</div>
						<AlertBox role="alert">
							<i className="fa-solid fa-circle-exclamation" />
							<Trans i18nKey="womenWarning">
								Evite <strong>salto fino</strong>, e vestidos nos tons{' '}
								<strong>branco</strong>, <strong>off-white</strong>,{' '}
								<strong>lilás</strong> e <strong>lavanda</strong>
							</Trans>
						</AlertBox>
					</DressCodeContainer>
				</SectionContent>

				<SectionContent>
					<ItemTitle>
						{t('Compartilhe o Amor')} <ImageIcon src={camera} alt="" />
					</ItemTitle>
					<ItemContainer>
						<ItemIcon src={mapleLeaf} alt="Folha de bordo" />
						<ItemDescription>
							{t(
								'Seja nosso fotógrafo de honra, e se utilizar o Instagram não esqueça de usar a nossa hashtag',
							)}{' '}
							<Hashtag>#casamentoeltonethais</Hashtag> {t('e de nos marcar')}{' '}
							<Tagging
								href="https://instagram.com/eltonviana_"
								rel="noopener noreferrer"
								target="_blank"
							>
								@eltonviana_
							</Tagging>{' '}
							<Tagging
								href="https://instagram.com/thaislins"
								rel="noopener noreferrer"
								target="_blank"
							>
								@thaislins
							</Tagging>{' '}
							{t(
								'para que possamos ver todos os momentos registrados por vocês!',
							)}
						</ItemDescription>
					</ItemContainer>
				</SectionContent>

				<SectionContent>
					<ItemTitle>{t('Pedidos dos noivos')}</ItemTitle>
					<ItemContainer>
						<ItemIcon src={mapleLeaf} alt="Folha de bordo" />
						<ItemDescription>
							{t('Por favor confirme sua presença: O cerimonial entrará em contato para confirmar sua presença')}
						</ItemDescription>
					</ItemContainer>
					<ItemContainer>
						<ItemIcon src={mapleLeaf} alt="Folha de bordo" />
						<ItemDescription>
							{t('Por favor não se atrase para a cerimônia')}
						</ItemDescription>
					</ItemContainer>
				</SectionContent>
			</div>
		</InfoWrapper>
	)
}

export default Info
